import Header from "@/components/Header";
import Footer from "@/components/Footer";

const PAGES = {
  "privacidade": {
    title: "Política de Privacidade",
    body: [
      ["Responsável pelo tratamento", "A SOLUTION CAR PREMIUM é a responsável pelo tratamento dos seus dados pessoais, nos termos do Regulamento Geral sobre a Proteção de Dados (RGPD) e da legislação portuguesa aplicável."],
      ["Dados que recolhemos", "Recolhemos os dados que nos fornece nos formulários de contacto, registo de conta, pedidos de importação e financiamento, e documentos que submete na sua área de cliente (nome, email, telefone, NIF, morada, código postal)."],
      ["Finalidade", "Os seus dados são utilizados exclusivamente para responder aos seus pedidos, gerir os seus processos de compra, importação e financiamento, e cumprir obrigações legais."],
      ["Conservação", "Conservamos os seus dados apenas pelo período necessário à finalidade para que foram recolhidos e às obrigações legais de conservação."],
      ["Os seus direitos", "Tem direito a aceder, retificar, apagar, limitar ou opor-se ao tratamento dos seus dados, bem como à portabilidade. Para exercer estes direitos, contacte-nos através dos meios indicados na página de contactos."],
      ["Segurança", "As suas palavras-passe são protegidas com hash seguro e os documentos são armazenados de forma privada, nunca acessíveis por ligações públicas. Todas as ligações são feitas por HTTPS."],
    ],
  },
  "cookies": {
    title: "Política de Cookies",
    body: [
      ["O que são cookies", "Cookies são pequenos ficheiros de texto armazenados no seu dispositivo que ajudam o website a funcionar corretamente."],
      ["Cookies que utilizamos", "Utilizamos cookies estritamente necessários ao funcionamento da autenticação e da sua sessão, e cookies de análise anónima para melhorar o website."],
      ["Gestão", "Pode gerir ou eliminar os cookies nas definições do seu navegador. Ao continuar a usar o website, aceita a utilização de cookies necessários."],
    ],
  },
  "termos": {
    title: "Termos e Condições",
    body: [
      ["Objeto", "Os presentes termos regulam a utilização do website da SOLUTION CAR PREMIUM e dos serviços de comercialização, importação e apoio ao financiamento automóvel."],
      ["Simulações", "O simulador de financiamento tem caráter meramente indicativo e não constitui aprovação de crédito. As propostas finais dependem da análise da entidade financeira e das condições legalmente aplicáveis."],
      ["Importação", "Os pedidos de importação estão sujeitos a cotação prévia, com apresentação do custo total (viatura, transporte, ISV e legalização) antes de qualquer compromisso."],
      ["Responsabilidade", "A informação de viaturas é apresentada de boa-fé e pode conter erros tipográficos. A disponibilidade e o preço são confirmados no contacto."],
      ["Legislação aplicável", "Aplica-se a lei portuguesa. Para qualquer litígio, é competente o foro da comarca da sede da empresa, salvo disposição legal em contrário."],
    ],
  },
};

export default function LegalPage({ page }) {
  const content = PAGES[page];
  if (!content) return null;
  return (
    <div className="min-h-screen bg-white" data-testid={`legal-${page}`}>
      <Header />
      <main className="pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <h1 className="font-display text-4xl tracking-tight text-[#0072C6] mb-4">{content.title}</h1>
          <p className="text-xs text-slate-400 mb-10">Última atualização: novembro de 2026</p>
          <div className="space-y-8">
            {content.body.map(([h, p]) => (
              <section key={h}>
                <h2 className="font-display text-xl text-[#0072C6] mb-2">{h}</h2>
                <p className="text-slate-600 leading-relaxed text-sm">{p}</p>
              </section>
            ))}
          </div>
          <p className="mt-12 text-sm text-slate-500 border-t border-slate-100 pt-6">
            Estes textos são uma base. Recomendamos a revisão por um jurista para adequação completa ao seu caso.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
